import React from 'react';
import { getIntl } from '../../../../utils/intl';
import useIsTestUser from '../../../../hooks/useIsTestUser';
import { useAdminListedOrganizations } from '../../../../hooks/api/useAdminListedOrganizations';
import Stack, { contentStackSpacing } from '../../../v2BaseComponents/Stack';
import { Checkbox, Select } from '../../../v2BaseComponents/Inputs';
import Button from '../../../v2BaseComponents/Button';
import Divider from '../../../v2BaseComponents/Divider';
import Text from '../../../v2BaseComponents/Text';

const intl = getIntl('toggle-org-paid-status', {
    orgToToggle: 'Organization to toggle',
    isPaid: 'Is paid?',
    update: 'Update',
    updateOrgPaidStatus: 'Update organization paid status',
});

export type ToggleOrgPaidStatusOwnProps = {};

export type ToggleOrgPaidStatusProps = ToggleOrgPaidStatusOwnProps;

const ToggleOrgPaidStatus: React.FC<ToggleOrgPaidStatusProps> = (_props) => {
    const isTestUser = useIsTestUser();
    const [isPaid, setIsPaid] = React.useState(false);
    const [orgId, setOrgId] = React.useState<null | string>(null);
    const { adminListedOrganizations, updatePaidStatus, isUpdatingPaidStatus } = useAdminListedOrganizations({
        onUpdatedPaidStatus: () => {
            setOrgId(null);
            setIsPaid(false);
        },
    });

    if (!isTestUser) return null;

    return (
        <Stack vertical space={contentStackSpacing} style={{ alignSelf: 'stretch' }} align="flex-start">
            <Divider horizontal />
            <Text variant="h5">{intl('updateOrgPaidStatus')}</Text>
            <Select
                title={intl('orgToToggle')}
                selectOptions={adminListedOrganizations
                    .sort((a, b) => (a.organizationName || '').localeCompare(b.organizationName || ''))
                    .map((org) => ({
                        label: org.organizationName,
                        value: org.organizationId,
                    }))}
                value={orgId}
                onChange={(value) => {
                    setOrgId(value as string);
                    const org = adminListedOrganizations.find((org) => org.organizationId === value);
                    if (org) {
                        setIsPaid(org.isPaid);
                    }
                }}
            />
            {orgId ? <Checkbox title={intl('isPaid')} value={isPaid} onChange={setIsPaid} /> : null}
            {orgId ? (
                <Button
                    title={intl('update')}
                    onPress={() => updatePaidStatus({ organizationId: orgId, isPaid })}
                    isDisabled={isUpdatingPaidStatus}
                />
            ) : null}

            <Divider horizontal />
        </Stack>
    );
};

export default React.memo(ToggleOrgPaidStatus);
